import { Image } from "antd";
import React from "react";
import IMG from "./../../../../assets/tinyimg/gcash.webp";

const GcashDesign = () => {
  return (
    <div
      style={{
        // border: "1px solid red",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#015de6",
      }}
    >
      <Image
        width={"auto"}
        height={250}
        src={IMG}
        placeholder={"gcash"}
        preview={true}
        alt="gcash-img"
      />
    </div>
  );
};

export default GcashDesign;
